import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import InsideTrainingList from '../InsideTrainingList/Index';
import OutsideTrainingList from '../OutsideTrainingList/Index';
import CorrespondenceCourseList from '../CorrespondenceCourseList/Index';

const theme = createTheme({
  palette: {
    secondary: {
      main: '#357ebd',
    },
  },
});

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  // boxShadow: 24,
  pl: 6,
  pr: 6,
  pt: 0.5,
  pb: 6,
};
const closeButtonStyle = {
  height: 40,
  textAlign: "right",
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


function TrainingList(props){

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Modal
      open={props.open}
      onClose={() => props.setOpen(false)}
    >
      <Box sx={style}>
        <Box sx={closeButtonStyle}>
          <IconButton onClick={() => props.setOpen(false)}>
            <CloseIcon fontSize={'large'} />
          </IconButton>
        </Box>
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <ThemeProvider theme={theme}>
              <Tabs
                value={value}
                onChange={handleChange}
                TabIndicatorProps={{
                  style: {
                    backgroundColor: "#357ebd"
                  }
                }}
                textColor={'secondary'}
              >
                <Tab label="社内研修" {...a11yProps(0)} />
                <Tab label="社外研修" {...a11yProps(1)} />
                <Tab label="通信講座" {...a11yProps(2)} />
              </Tabs>
            </ThemeProvider>
          </Box>
          <TabPanel value={value} index={0}>
            <InsideTrainingList />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <OutsideTrainingList />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <CorrespondenceCourseList />
          </TabPanel>
        </Box>
      </Box>
    </Modal>      
  );
};

export default TrainingList;
